import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  mostrarPublicidad: boolean = true;

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router) {
    _activatedRoute.queryParams.subscribe(
      params => this.mostrarPublicidad = !params['hb']
    );
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    if (this.mostrarPublicidad) {
      $(document).ready(function () {
        $("button").click();
      });
    } else {
      this._router.navigate(['']);
    }
  }

}
